import { render, staticRenderFns } from "./CreateQualite.vue?vue&type=template&id=6bb2294e"
import script from "./CreateQualite.vue?vue&type=script&lang=js"
export * from "./CreateQualite.vue?vue&type=script&lang=js"
import style0 from "./CreateQualite.vue?vue&type=style&index=0&id=6bb2294e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports